import { Component, OnInit, Inject } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";

@Component({
  selector: "app-dialog-busqueda-producto",
  templateUrl: "./dialog-busqueda-producto.component.html",
  styleUrls: ["./dialog-busqueda-producto.component.css"],
})
export class DialogBusquedaProductoComponent implements OnInit {
  productosLista = [];

  constructor(
    @Inject(MAT_DIALOG_DATA) public dataDialog: any,
    private dialogRef: MatDialogRef<DialogBusquedaProductoComponent>
  ) {
    this.productosLista = this.dataDialog;
  }

  ngOnInit(): void {}

  productoSeleccionado(producto) {
    //console.log(persona);
    this.dialogRef.close(producto);
  }
}
